import { addSeconds, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

/**
 * Adds seconds to an ISO 8601 formatted string and returns the new date as a string.
 * @param timeString - The ISO 8601 formatted date string.
 * @param seconds - The number of seconds to add.
 * @param timezone - The timezone to format the new date in.
 * @returns The new date as an ISO 8601 formatted string.
 */
export const addSecondsToISOString = (timeString: string, seconds: number, timezone: string) => {
  const newDate = addSeconds(parseISO(timeString), seconds);
  return toISOString(newDate, timezone);
};

export const toISOString = (date: string | number | Date, timezone: string) => {
  // Note that the fallback is for extremely rare use cases where we may not have the date:
  // eg: if we are missing storeLocalTime
  return formatInTimeZone(date || new Date(), timezone, "yyyy-MM-dd'T'HH:mm:ss.sssXXX");
};
